var map = {
	"./BCA SYARIAH.png": 6387,
	"./BCA.png": 5165,
	"./BJB.png": 118,
	"./BNI SYARIAH.png": 4499,
	"./BNI.png": 7263,
	"./BRI SYARIAH.png": 114,
	"./BRI.png": 2904,
	"./BSI.png": 1820,
	"./BTN.png": 3781,
	"./BTPN.png": 284,
	"./CIMB.png": 33,
	"./DANA.png": 8904,
	"./DANAMON.png": 5417,
	"./GOPAY.png": 6803,
	"./JATIM.png": 8260,
	"./MANDIRI SYARIAH.png": 6081,
	"./MANDIRI.png": 2366,
	"./MAYBANK.png": 2851,
	"./NOBU.png": 5607,
	"./OVO.png": 8894,
	"./PERMATA.png": 3115,
	"./SHOPEEPAY.png": 4438,
	"./SINARMAS.png": 8216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7234;